import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { EnvelopeSimple } from "@phosphor-icons/react";
import { api, fmtDateUK } from "@/lib/api";

// Saved and sent Flash Report email drafts for one client.
export function EmailDraftsPanel({ clientId }) {
  const [drafts, setDrafts] = useState(null);

  useEffect(() => {
    api.get(`/clients/${clientId}/flash-email/drafts`).then(({ data }) => setDrafts(data.drafts)).catch(() => setDrafts([]));
  }, [clientId]);

  return (
    <div className="bg-white border border-[#E2E8F0] rounded-md card-fade mb-6" data-testid="email-drafts-panel">
      <div className="px-6 pt-5 pb-3">
        <p className="uppercase text-[11px] tracking-[0.2em] text-[#475569] font-medium">Flash Report emails</p>
        <p className="text-xs text-[#64748B] mt-1">Start a new draft from the Flash Report button above. Drafts are saved here until sent.</p>
      </div>
      {drafts === null ? (
        <p className="px-6 pb-5 text-xs text-[#94A3B8]">Loading…</p>
      ) : drafts.length === 0 ? (
        <p className="px-6 pb-5 text-xs text-[#94A3B8]" data-testid="email-drafts-empty">No drafts yet.</p>
      ) : (
        <ul className="divide-y divide-[#EEEEEE] border-t border-[#EEEEEE]">
          {drafts.map((d) => (
            <li key={d.id}>
              <Link to={`/admin/email-drafts/${d.id}`} className="flex items-center gap-4 px-6 py-3 hover:bg-[#F5F5F5] transition-colors" data-testid={`email-draft-${d.id}`}>
                <EnvelopeSimple size={16} className="text-[#64748B] shrink-0" />
                <div className="min-w-0 flex-1">
                  <p className="text-sm text-[#0F172A] truncate">{d.subject}</p>
                  <p className="text-[11px] font-mono text-[#94A3B8] truncate">{(d.recipients || []).join(", ") || "No recipients yet"}</p>
                </div>
                <span className={`text-[11px] uppercase tracking-[0.14em] font-semibold ${d.status === "sent" ? "text-[#059669]" : "text-[#B45309]"}`}>
                  {d.status === "sent" ? `Sent ${fmtDateUK(d.sent_at)}` : `Draft · ${fmtDateUK(d.updated_at)}`}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
